import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { GenericFilterModel } from 'src/app/security/QueryStringParam';
import { AnnouncementModel, Contacts, DataItemModel } from '../../../shared/model/interfaces';
import {extractContacts, getErrorMessageText} from '../../helper';

@Component({
  selector: 'app-custodian-home',
  templateUrl: './custodian-home.component.html',
  styleUrls: ['./custodian-home.component.css']
})
export class CustodianHomeComponent implements OnInit {

  public forms: DataItemModel[] = [];
  public statements: DataItemModel[] = [];
  public taxes: DataItemModel[] = [];
  public communications: DataItemModel[] = [];
  public confirms: DataItemModel[] = [];
  public Announcements: AnnouncementModel[] = [];
  public OwnerShipType = '-';
  public CustodianAccNum = '-';
  public contacts: Contacts;
  public differentLoggedIn: boolean;
  public custodianInfo: any;
  display = false;
  alertmessage: string;
  InboxCount = 0;

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private ngxService: NgxUiLoaderService,
    private authService: AuthServiceCustom) {
  }

  ngOnInit() {
    this.differentLoggedIn = this.authService.DifferentLoggedIn;
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];

    genericFilterModel.PageNo = 0;
    genericFilterModel.PageSize = 3;
    genericFilterModel.SortField = '';
    genericFilterModel.SortOrder = '';
    genericFilterModel.SkipRecords = 0;
    genericFilterModel.Filters.push({Key: 'forWhat', Value: 'announcement'});

    forkJoin(
      this.abstractDataProvider.postData(genericFilterModel, 'api/Form/GetForm'),
      this.abstractDataProvider.getData('api/Custodian/GetCustodianInfo'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetNewMessageCount'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetInbox'),
    )
      .subscribe(([forms, custodian, inbox, announcement]) => {
          this.ngxService.stop();
          this.custodianInfo = custodian;

          this.contacts = extractContacts(custodian);

          this.OwnerShipType = custodian.OwnerShipType;
          this.CustodianAccNum = custodian.CustodianAccNum;

          this.forms = forms.Data.slice(0, 4);
          this.InboxCount = inbox.InboxCount;
          this.Announcements = announcement.Data;
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertmessage =  getErrorMessageText(error);

        });
  }


  onConfirm() {
    this.display = false;
  }


  navigateToUnReadMsg() {
    this.authService.navigateToUrl('inbox', {mode: 'unread'});
  }

}
